let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i42Vc")).then(() => parcelRequire('5dOp9'));